import $ from "jquery";

/**
 * Misc nav related items.
 */
const nav = {
  /**
   * Toggle subnav dropdowns
   * @param  {object} $el
   */
  toggleSubnav($el) {
    $el.toggleClass("sub-nav__link--dropdown--open");
    $el.next(".sub-nav__dropdown").toggleClass("sub-nav__dropdown--open");
  },

  /**
   */
  bindEventHandlers() {
    const self = this;
    $(".sub-nav__link--dropdown").on("click", function (event) {
      event.preventDefault();
      self.toggleSubnav($(this));
    });

    const $body = $("body");
    const hoverNavClass = "body--animate-header";
    $(".nav__link")
      .on("mouseover", function () {
        if (!$(this).hasClass("nav__link--active")) {
          $body.addClass(hoverNavClass);
        }
      })
      .on("mouseout", () => {
        $body.removeClass(hoverNavClass);
      });
  },

  /**
   * By default, the subnavs are loaded in their open state to support JS being disabled.
   * If we're here, JS is enabled; if it's a smaller device, close the nav on initial load.
   */
  closeSubnavOnSmallerDevices() {
    const width = $("body").outerWidth();
    if (width <= 1000) {
      const self = this;
      $(".sub-nav__link--dropdown--open").each(function () {
        self.toggleSubnav($(this));
      });
    }
  },

  /**
   * Init module
   */
  init() {
    this.bindEventHandlers();
    this.closeSubnavOnSmallerDevices();
  },
};

export default nav;
